import Action from "./Action";
import Piou, { PiouStep } from "../Piou";
import { ActionType } from "./index";

export default class Jump extends Action {
  constructor(piou: Piou) {
    super(ActionType.JUMP, piou);
  }

  init() {
    super.init();
    this.piou.initStep(PiouStep.FLY);
    this.piou.vx = (3.5 + this.piou.speed) * this.piou.sens;
    this.piou.vy = -6;
    this.piou.root.gotoAndStop("jump");
    this.piou.bouncer?.once("bounce", this.bang.bind(this));
  }

  update() {
    super.update();
    // this.piou.root.angle = this.piou.vy * 10 * this.piou.sens;
  }

  bang() {
    console.log("bang");
    const ovy = this.piou.vy;
    this.piou.initStep(PiouStep.FALL);
    this.piou.root.rotation = 0;
    if (ovy >= Piou.FALL_DEATH_LIMIT) this.piou.vy = ovy;
    this.interrupt();
  }

  interrupt() {
    super.interrupt();
  }
}
